import PublicAppLogo from './PublicAppLogo'

export default PublicAppLogo
